import { SkeletonLoading } from '@saleshandy/design-system';
import React from 'react';
import { Spinner } from 'react-bootstrap';
import Table from '../../../../shared/design-system/components/organisms/table';
import { PaginationShowHide } from '../../../../shared/design-system/components/organisms/table/types';

const DashboardFallback: React.FC = () => {
  const columns = [
    {
      dataField: 'name',
      text: 'Test Names',
      headerLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      cellLoadingSkeleton: (
        <div className="test-name-skeleton">
          <SkeletonLoading width={102} height={14} />
          <div className="test-type">
            <SkeletonLoading width={58} height={14} />
            <SkeletonLoading width={58} height={14} />
            <SkeletonLoading width={58} height={14} />
          </div>
        </div>
      ),
      headerClasses: 'test-name-header',
      cellClasses: 'test-name-cell',
    },
    {
      dataField: 'testProgress',
      text: 'Test Progress',
      headerLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      headerClasses: 'test-progress-header',
      cellClasses: 'test-progress-cell',
    },
    {
      dataField: 'inboxScore',
      text: 'Inbox Score',
      headerLoadingSkeleton: <SkeletonLoading width={60} height={14} />,
      cellLoadingSkeleton: (
        <SkeletonLoading width={32} height={24} borderRadius={20} />
      ),
      headerClasses: 'inbox-score-header',
      cellClasses: 'inbox-score-cell',
    },
    {
      dataField: 'inbox',
      text: 'Inbox',
      headerLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      headerClasses: 'inbox-count-header',
      cellClasses: 'inbox-count-cell',
    },
    {
      dataField: 'spam',
      text: 'Spam',
      headerLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      headerClasses: 'spam-count-header',
      cellClasses: 'spam-count-cell',
    },
    {
      dataField: 'others',
      text: 'Other',
      headerLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      headerClasses: 'other-count-header',
      cellClasses: 'other-count-cell',
    },
    {
      dataField: 'notDelivered',
      text: 'Undelivered',
      headerLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      headerClasses: 'undelivered-count-header',
      cellClasses: 'undelivered-count-cell',
    },
    {
      dataField: 'lastRunOn',
      text: 'Last Run On',
      headerLoadingSkeleton: <SkeletonLoading width={82} height={14} />,
      cellLoadingSkeleton: <SkeletonLoading width={168} height={14} />,
      headerClasses: 'last-run-on-header',
      cellClasses: 'last-run-on-cell',
    },
    {
      dataField: 'userName',
      text: 'Created By',
      headerLoadingSkeleton: <SkeletonLoading width={90} height={14} />,
      cellLoadingSkeleton: (
        <div className="test-redirect-link">
          <div className="d-flex align-items-center">
            <SkeletonLoading width={24} height={24} circle />
            <div style={{ marginLeft: '10px' }}>
              <SkeletonLoading width={80} height={14} />
            </div>
          </div>
        </div>
      ),
      headerClasses: 'created-by-header',
      cellClasses: 'created-by-cell',
    },
  ];

  return (
    <div className="dashboard-container">
      <div className="dashboard-header d-flex justify-content-between align-items-center">
        <div className="dashboard-header-left d-flex align-items-center">
          <SkeletonLoading width={195} height={32} />
        </div>
        <div className="dashboard-header-right d-flex align-items-center">
          <SkeletonLoading width={202} height={32} className="mr-3" />
          <SkeletonLoading width={110} height={32} />
        </div>
      </div>
      <div className="dashboard-content">
        <div className="dashboard-summary-graph-container">
          <div className="dashboard-summary-container">
            {Array.from({ length: 4 }).map((_, index) => (
              // eslint-disable-next-line react/no-array-index-key
              <div key={index} className="dashboard-summary-card">
                <SkeletonLoading width={62} height={14} />
                <SkeletonLoading width={52} height={36} />
              </div>
            ))}
          </div>
          <div className="dashboard-graph-container">
            <div className="inbox-radar-graph-container">
              <div className="inbox-radar-graph-header">
                <div className="graph-filters__middle">
                  <div className="d-flex time-frame">
                    <SkeletonLoading height={24} width={71} />
                    <SkeletonLoading height={24} width={71} />
                    <SkeletonLoading height={24} width={71} />
                    <SkeletonLoading height={24} width={71} />
                  </div>
                </div>
              </div>
              <div className="graph-loading-container">
                <div className="graph-loading-inner">
                  <Spinner animation="border" />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="dashboard-test-list-container">
          <div className="dashboard-test-list">
            <Table
              data={[]}
              columns={columns}
              isLoading={true}
              pagination={PaginationShowHide.HIDE}
              paginationOptions={{
                options: {
                  page: 1,
                  limit: 10,
                  totalElements: 10,
                },
              }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DashboardFallback;
